var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 9,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66571 11.4174C2.16095 11.4188 1.66691 11.5631 1.24074 11.8336C0.814566 12.1041 0.473682 12.4897 0.257524 12.9458C0.0413654 13.402 -0.0412333 13.91 0.0192836 14.4111C0.0798006 14.9122 0.28096 15.386 0.599489 15.7775L7.38979 24.0956C7.63189 24.3962 7.94224 24.6348 8.29504 24.7914C8.64784 24.948 9.03291 25.0181 9.41827 24.996C10.2425 24.9518 10.9866 24.5109 11.461 23.7859L25.5662 1.06957C25.5685 1.06581 25.5709 1.06204 25.5734 1.05833C25.7057 0.855117 25.6628 0.452412 25.3896 0.199428C25.3146 0.129955 25.2261 0.0765813 25.1296 0.0425924C25.0332 0.00860354 24.9308 -0.00528042 24.8288 0.00179589C24.7268 0.0088722 24.6273 0.036759 24.5364 0.0837384C24.4456 0.130718 24.3654 0.195795 24.3006 0.274963C24.2956 0.281188 24.2903 0.287318 24.285 0.293355L10.0597 16.3658C10.0056 16.4269 9.93986 16.4767 9.86632 16.5123C9.79279 16.5478 9.71292 16.5684 9.63137 16.5728C9.54981 16.5772 9.46819 16.5654 9.39125 16.538C9.31431 16.5106 9.24358 16.4681 9.18317 16.4132L4.46208 12.117C3.97175 11.6675 3.33088 11.4179 2.66571 11.4174Z",
    fill: "#50DE1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/Tick.fdbf480a1323a81e61bcb860a786ac4f.svg";
export { ForwardRef as ReactComponent };